<template>
  <router-view name="comment" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Comment",
};
</script>
